import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js"
import { useState } from "react"
import { Line, Pie } from "react-chartjs-2"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import AcademicYearSelect from "../common/AcademicYearSelect"

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Some title",
    },
  },
}

const labels = ["January", "February", "March", "April", "May", "June", "July"]

export const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: labels.map(() => 100),
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "Dataset 2",
      data: labels.map(() => 200),
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
}

const num = 10

const Sessions = () => {
  const [year, setYear] = useState(2023)

  const [curr, setCurr] = useState(0)
  const next = () => {
    if (curr < num - 1) setCurr(curr + 1)
  }
  const prev = () => {
    if (curr > 0) setCurr(curr - 1)
  }

  return (
    <Box sx={{ width: { sm: "calc(100vw - 400px)" } }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <AcademicYearSelect value={year} setValue={setYear} />
        {year === 2023 && <Button variant="contained">Create Session</Button>}
      </Stack>

      <Box sx={{ overflow: "hidden", py: 1, px: 6, position: "relative" }}>
        <IconButton
          onClick={prev}
          sx={{
            position: "absolute",
            top: "30%",
            left: 0,
            background: "white",
            boxShadow: 1,
            "&:hover": {
              background: "white",
            },
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          onClick={next}
          sx={{
            position: "absolute",
            top: "30%",
            right: 0,
            background: "white",
            boxShadow: 1,
            "&:hover": {
              background: "white",
            },
          }}
        >
          <ChevronRightIcon />
        </IconButton>
        <Stack
          direction="row"
          sx={{
            gap: "1rem",
            marginLeft: "-" + curr * 17 + "rem",
            transition: "margin 0.6s",
          }}
        >
          {Array(num)
            .fill(0)
            .map(() => (
              <Stat label="Stat 1" val="20" />
            ))}
        </Stack>
      </Box>

      <Grid container mt={2} spacing={2}>
        <GraphBox>
          <Line options={options} data={data} />
        </GraphBox>
        <GraphBox>
          <Pie options={options} data={data} />
        </GraphBox>
      </Grid>
    </Box>
  )
}

const Stat = ({ label, val }) => (
  <Paper sx={{ p: 2, width: "16rem", flex: "none" }}>
    <Typography fontWeight={500} mb={1}>
      {label}
    </Typography>
    <Typography fontWeight={600} variant="h5">
      {val}
    </Typography>
  </Paper>
)

const GraphBox = ({ children }) => {
  return (
    <Grid item xs={6}>
      <Paper
        sx={{
          p: 2,
          height: "20rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {children}
      </Paper>
    </Grid>
  )
}

export default Sessions
